import React from 'react'

export const Space = ({ width, height, ...rest }) => (
  <div
    {...(width ? { display: 'inline-block' } : {})}
    style={{ width, height }}
  />
)
